import React, { FC } from 'react';
import { SettingsView } from '../components';

export const SettingsPage: FC = () => {
  return <SettingsView />;
};
